import { render, staticRenderFns } from "./ShotValFirstSlide.vue?vue&type=template&id=3670a8b4&"
import script from "./ShotValFirstSlide.vue?vue&type=script&lang=js&"
export * from "./ShotValFirstSlide.vue?vue&type=script&lang=js&"
import style0 from "./ShotValFirstSlide.vue?vue&type=style&index=0&id=3670a8b4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports